<template>
  <BaseFilter
    :title="`recent planned ${tripModule.trip} filter`"
    :isChips="isChips"
    @submit="$emit('apply')"
    @reset="$emit('reset')"
    @filterDialogOpen="getTripPlanningOptions"
    :isIcon="false"
    newClass="mr-1"
  >
    <template #form>
      <v-row class="ma-0">
        <v-col cols="12">
          <SelectField
            id="trip_status"
            name="trip_status"
            :itemsList="statusList"
            itemText="display_value"
            itemValue="value"
            :multiple="true"
            :label="`select ${statusMapping.tripStatus}`"
            v-model="bindFilters.status"
            :isMounted="true"
            :dense="true"
          />
        </v-col>
      </v-row>
    </template>
  </BaseFilter>
</template>

<script>
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { bus } from "@/main";
import { tripModule, statusMapping } from "@/utils/moduleMapping";
export default {
  components: {
    BaseFilter,
  },
  props: {
    value: Boolean,
    isChips: Boolean,
    filterObject: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tripModule,
      statusMapping,
      statusList: [],
    };
  },
  computed: {
    bindFilters: {
      get() {
        return this.filterObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getTripPlanningOptions() {
      bus.$emit("showLoader", true);
      this.$api.tripPlanning
        .getTripPlanningOptions({ request_type: "filter" })
        .then((res) => {
          this.statusList = res?.data?.status;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
